import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const handleScrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('pricing');
    if (!target) return;
    const startY = window.scrollY;
    const endY = target.getBoundingClientRect().top + window.scrollY;
    const distance = endY - startY;
    const duration = 1500;
    let startTime: number | null = null;
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (timestamp: number) => {
      if (startTime === null) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <section className="bg-white pt-8 pb-12 md:pt-16 md:pb-16 px-4 relative overflow-hidden" data-id="element-93">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-orange/5 rounded-full blur-[140px] pointer-events-none" data-id="element-94"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          <span className="inline-block text-[10px] md:text-sm text-navy bg-lightgray border border-border rounded-full px-3 py-0.5 md:px-4 md:py-1 mb-3 md:mb-4 font-bold shadow-sm uppercase tracking-wider" data-id="element-97">
            🧠 EUREKALABS.STORE
          </span>
          <h1 className="font-heading font-black text-navy mb-2 md:mb-4 text-2xl sm:text-3xl md:text-5xl lg:text-6xl leading-tight px-2 sm:px-8 max-w-4xl mx-auto tracking-tight" data-id="element-98">
            MEGAPACK NEURO-KID™
          </h1>
          <p className="text-orange font-bold text-lg md:text-2xl mb-2 tracking-wide" data-id="element-99">
            100+ Screen-Free Brain Training Activities for Kids Ages 3-12
          </p>
          <p className="text-green font-bold text-base md:text-xl text-center" data-id="element-100">
            ✅ Ready-to-use material
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-6 mb-4 md:mt-8 md:mb-6 flex justify-center" data-id="element-101">
          <img src="https://cdn.magicpatterns.com/uploads/dsCNWqtaZzkSPVHFpETuCK/MOCKUP_NEURO_KID.png" alt="Megapack Neuro-Kid" className="w-full max-w-[280px] md:max-w-[420px] mx-auto drop-shadow-[0_20px_50px_rgba(27,46,75,0.2)]" data-id="element-102" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-navy md:text-lg max-w-3xl mx-auto font-bold text-base mb-6" data-id="element-103">
          Every minute on a screen quietly rewires your child's brain for
          distraction. This is the system that rewires it back — in just 10
          minutes a day.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="max-w-2xl mx-auto" data-id="element-104">
          <a href="#pricing" onClick={handleScrollToPricing} className="inline-block bg-orange hover:bg-orange-dark text-white font-heading font-bold text-base md:text-xl py-4 px-8 md:py-5 md:px-12 rounded-full shadow-[0_10px_30px_rgba(255,107,43,0.4)] transition-all hover:scale-105 active:scale-95 mb-5 leading-tight cursor-pointer" data-id="element-105">
            YES — Give My Child The Focus They Deserve →
          </a>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 md:gap-6 text-[12px] md:text-sm text-muted font-semibold" data-id="element-106">
            <div className="flex items-center" data-id="element-107">
              <Lock className="w-4 h-4 mr-1 text-green" data-id="element-108" /> Instant Access
            </div>
            <div className="flex items-center" data-id="element-109">
              <Shield className="w-4 h-4 mr-1 text-green" data-id="element-110" /> 7-Day Guarantee
            </div>
            <div className="flex items-center" data-id="element-111">
              <CreditCard className="w-4 h-4 mr-1 text-green" data-id="element-112" /> Secure Payment
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}